/*
 Note:
 This component is included directly into the sources of this project to simplify the
 build process.

 License:
 Copyright 2019, Indoqa Software Design und Beratung GmbH

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:
 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
 THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
import {UseComboboxState, UseComboboxStateChangeOptions} from 'downshift'
import {IStyle} from 'fela'
import * as React from 'react'

export enum AutoCompleteItemTargetType {
  COMPLETION = 'completion',
  SUGGESTION = 'suggestion',
}

export interface AutoCompleteItem {
  proposal: string | string[]
  targetType: AutoCompleteItemTargetType
  text: string | string[]
}

export type RenderItem<T> = (item: T) => JSX.Element

export type RenderIcon = () => React.ReactNode

export type ReduceState<T> = (
  state: UseComboboxState<T>,
  actionAndChanges: UseComboboxStateChangeOptions<T>
) => UseComboboxState<T>

export type Reload = (prefix: string, pos: number | null) => void

export type OnCompletionSelected = (text: string) => void

export type Search = (userInput: string) => void

export type Clear = () => void

export type SelectSuggestion<T> = (item: T) => void

export interface StyleConfig {
  borderRadius: number
  borderStyle: string
  comboboxBackgroundColor: string
  highlightColor: string
  paddingRight: number | string
  paddingLeft: number | string
  menuPaddingTop: number | string
  menuPaddingBottom: number | string
  menuBackgroundColor: string
  itemPaddingTop: number | string
  itemPaddingBottom: number | string
  iconContainerWidth: number | string
  shadow: boolean
  shadowCombobox: string
  shadowMenu: string
  showIconIcons: boolean
}

export interface StyleSearchInputProps {
  active: boolean
  showCompletions: boolean
}

export type StyleSearchInputComponent = (config: StyleConfig, props: StyleSearchInputProps) => IStyle

export interface SearchInputStyles {
  styleContainer: StyleSearchInputComponent
  styleComboBox: StyleSearchInputComponent
  styleInput: StyleSearchInputComponent
  styleMenu: StyleSearchInputComponent
  styleMenuItem: StyleSearchInputComponent
  styleIconContainer: StyleSearchInputComponent
}
